import { put, call, takeEvery } from 'typed-redux-saga';
import { toast } from 'react-toastify';

import SettingGateway from '~apis/setting';
import combinedActions from '~redux/combinedActions';
import { store } from '~redux/store';

import { GatewayResponseStatus } from '~types/gateway';
import { SagaWatcherReturnType } from '~types/saga';

import { ErrorMessages } from '~utils/constants';

export default function* watchGetSilverApiKeySettings(api: SettingGateway): SagaWatcherReturnType {
    yield takeEvery('setting/settingGetSilverAPIKeySettingsAttempt', handleGetSilverApiKeySettings, api);
}

function* handleGetSilverApiKeySettings(api: SettingGateway) {
    const state = store.getState();

    const authToken = state.auth.userDetails.authToken;

    if (!authToken && authToken === undefined) {
        yield put(combinedActions.settingGetSilverAPIKeySettingsFailure(ErrorMessages.GenericRequiredFieldNotProvided));
        return;
    }

    const response = yield* call([api, api.getSilverApiKeySettings], { authToken });

    if (response.status === GatewayResponseStatus.Error) {
        yield put(combinedActions.settingGetSilverAPIKeySettingsFailure(response.message || ErrorMessages.GenericError));
        toast.error(response.message || ErrorMessages.GenericError);
        return;
    }

    if (response.status === GatewayResponseStatus.Success) {
        yield put(combinedActions.settingGetSilverAPIKeySettingsSuccess(response.data));
    }
}
